import ActionLink from './ActionLink';

export default ActionLink;
